import {CalendarLtrRegular, FlashRegular, AlertFilled, MoreHorizontalRegular} from "@fluentui/react-icons";
import {Avatar, Card, Button, Text, Menu, MenuTrigger, MenuPopover, MenuList, MenuItem} from "@fluentui/react-components";

import * as React from "react";
import Content from "../domain/Content";
import {AlertIds} from "../domain/CrossCommContentAlert";
import CrossCommContentAlert from "../domain/CrossCommContentAlert";

export interface INotificationItemProps {
    content: Content;
    onReadMore: (content: Content) => void;
    onDismiss: (content: Content) => void;
}
export default function NewsfeedItem (props: INotificationItemProps){
    function getAlertsDescription() {
        return (props.content.alerts && props.content.alerts.length > 0) ? props.content.alerts[0].description : "";
    }
    function getIcon() {
        const firstAlert: CrossCommContentAlert | undefined = (props.content.alerts && props.content.alerts.length > 0) ? props.content.alerts[0] : undefined;
        if (firstAlert) {
            if (firstAlert.id === AlertIds.EVENT_FOR_YOU_ID || firstAlert.id === AlertIds.HAPPENING_NOW_ID) {
                return (<CalendarLtrRegular fontSize="16px" style={{color: "var(--colorNeutralForegroundOnBrand)"}}/>);
            } else if (firstAlert.id === AlertIds.TRENDING_ID) {
                return (<FlashRegular fontSize="16px"  style={{color: "var(--colorNeutralForegroundOnBrand)"}}/>);
            } else if (firstAlert.id === AlertIds.BIG_NEWS_ID || firstAlert.id === AlertIds.TOP_STORY_ID || firstAlert.id === AlertIds.JUST_FOR_YOU_ID) {
                return (<AlertFilled fontSize="16px"  style={{color: "var(--colorNeutralForegroundOnBrand)"}}/>);
            }
        }
    }

    function handleOnDismiss  (e: any)  {
        e.preventDefault();
        e.stopPropagation();
        if (props.onDismiss) {
            props.onDismiss(props.content);
        }
    }

    function handleMenuTrigger (e: any){
        e.stopPropagation();
    }

    function handleOnReadMore (){
        if (props.onReadMore) {
            props.onReadMore(props.content);
        }
    }

    function render() {
        return (
            <div className="smt-flex smt-flex__gap-1 smt-flex__dir_column">
                <Card appearance="subtle" className="notification-item" selected={props.content.isDismissed || props.content.isClicked || props.content.hasNotificationImpression} onClick={handleOnReadMore} style={{marginBottom: "8px"}}>
                    <div className="smt-flex smt-flex__gap-2 ">
                        <Avatar  color="brand" shape="circular" icon={getIcon()} />
                        <div className="smt-flex smt-flex__dir_column smt-flex__gap-1 smt-filled">
                            <div className="smt-flex smt-flex__ai-center smt-flex__gap-1 smt-filled">
                                <Text size={300} weight="semibold" style={{color: "var(--colorNeutralForeground4)"}}>{getAlertsDescription()}</Text>
                                {
                                    !props.content.isDismissed &&
                                    (
                                        <div className="smt-flex__push">
                                            <Menu>
                                                <MenuTrigger>
                                                    <Button onClick={handleMenuTrigger} icon={<MoreHorizontalRegular/>}
                                                            appearance={"transparent"} title="More"/>
                                                </MenuTrigger>
                                                <MenuPopover>
                                                    <MenuList>
                                                        <MenuItem onClick={handleOnDismiss}>Dismiss</MenuItem>
                                                    </MenuList>
                                                </MenuPopover>
                                            </Menu>

                                        </div>
                                    )
                                }

                            </div>

                            <Text size={400} weight="semibold">{props.content.title}</Text>
                            <Text size={200}  style={{color: "var(--colorNeutralForeground4)"}}>{props.content.timeAgoSinceScheduled}</Text>
                        </div>
                    </div>

                </Card>
            </div>
       );
    }

    return render();
}
